<div class="ref-match-container" [ngClass]="getBorderClass()">

    <!-- MATCH -->
    <ng-template [ngIf]="!referenceIssue?.refFinding">
      <div class="ref-match-data-container">
        <div class="text-container">
          <p class="text">
            {{ ref?.refPhraseText }}
          </p>
          <ng-container *ngTemplateOutlet="matchAnchors"></ng-container>
        </div>
      </div>

      <div style="display: flex; flex-direction: column;">
        <div *ngIf="catMatchReference?.anchors != null && catMatchReference?.anchors.length > 0" class="copy-button-container">
          <ng-container *ngTemplateOutlet="copyButton"></ng-container>

        </div>
        <div class="ref-similarity-code">
          <p class="match">
            {{ "translate.rev.refMatch" | translate }}
          </p>
        </div>
      </div>
    </ng-template>

    <!-- MISSING_REFERENCE -->
    <ng-template [ngIf]="referenceIssue?.refFinding === 'MISSING_REFERENCE'">
      <div class="ref-match-data-container">
        <div class="text-container ref-similarity">
          <p class="text missing">
            {{ ref?.refPhraseText }}
          </p>
          <ng-container *ngTemplateOutlet="matchAnchors"></ng-container>
        </div>
        <div class="ref-info">
          <span class="footnote id">
            <!-- {{ "translate.cat.phraseId" | translate }}: {{ ref.refPhraseId }} -->
          </span>
        </div>
      </div>
      <div class="ref-similarity-code">
        <p class="missing">
          {{ "translate.rev.refMissing" | translate }}
        </p>
      </div>
    </ng-template>

    <!-- TEXT_MISMATCH -->
    <ng-template [ngIf]="referenceIssue?.refFinding === 'TEXT_MISMATCH'">

              <div class="ref-diff-container" style="position: relative;">
                <!-- Diff container -->
                <p class="text">
                  <span *ngIf="!showOriginal">
                    <ng-container *ngIf="!useCharBasedPhraseDiff; else charBasedDiffs">
                      <span *ngFor="let word of referenceIssue?.refDiffWords" class="match-diff"
                        [class.missing]="word.diffType == 'MISSING'" [class.extra]="word.diffType == 'EXTRA'">
                        {{ word.txt }}
                      </span>
                    </ng-container>
                    <ng-template #charBasedDiffs>
                      <char-based-phrase-diffs [workingPhrase]="ref.refPhraseText" [matched]="referenceIssue.originalReferenceIssueText" >

                      </char-based-phrase-diffs>
                    </ng-template>
                  </span>
                  <span *ngIf="showOriginal">
                    <div class="text-container">
                      <p class="text">
                        {{ referenceIssue.originalReferenceIssueText }}
                      </p>
                    </div>
                  </span>
                </p>
                <ng-container *ngTemplateOutlet="matchAnchors"></ng-container>
                <div class="ref-info">
                  <span class="footnote id">
                        {{ "translate.cat.phraseId" | translate }}: {{ referenceIssue.catRefPhraseId }}
                  </span>
                </div>
              </div>
              <div *ngIf="catMatchReference?.anchors != null && catMatchReference?.anchors.length > 0" class="copy-button-container mismatch">
                <ng-container *ngTemplateOutlet="copyButton"></ng-container>

              </div>
              <div *ngIf="!showOriginal">
                <button (click)="showOriginal = !showOriginal" class="eye-toggle" tooltip="{{ 'translate.rev.showOriginal' | translate }}">
                  <i class="fas fa-eye"></i>
                </button>
              </div>
              <div *ngIf="showOriginal">
                <button (click)="showOriginal = !showOriginal" class="eye-toggle" tooltip="{{ 'translate.rev.showDiff' | translate }}">
                  <i class="fas fa-eye-slash"></i>
                </button>
              </div>

    </ng-template>

    <!--ADDED_ANCHOR_REFERENCE-->
    <ng-template [ngIf]="referenceIssue?.refFinding === 'ADDED_ANCHOR_REFERENCE' || referenceIssue?.refFinding === 'COPIED_ANCHOR_REFERENCE'">
    <div class="ref-match-data-container" style="width: 100%;">
      <div style="display: flex;">
        <div class="text-container">
          <p class="text">
            {{ referenceIssue?.refText }}
          </p>
        </div>
        <div *ngIf="catMatchReference?.anchors != null && catMatchReference?.anchors.length > 0" class="copy-button-container added-anchor-reference">
          <ng-container *ngTemplateOutlet="copyButton"></ng-container>

        </div>
      </div>
      <ng-container *ngTemplateOutlet="matchAnchors"></ng-container>
    </div>
    </ng-template>
    <!-- ADDED_REFERENCE -->
    <ng-template [ngIf]="referenceIssue?.refFinding === 'ADDED_REFERENCE'">
      <div class="ref-match-data-container">
        <div class="text-container ref-similarity">
          <p class="text extra">
            {{ referenceIssue?.refText }}
          </p>
        </div>
      </div>
    </ng-template>
  <ng-template [ngIf]="referenceIssue?.refFinding === 'MISSING_ANCHOR_REFERENCE'">
    <div style="display: flex; flex-direction: column; gap: initial; width: 100% !important">
        <div class="ref-match-data-container">
          <div style="display: flex">

          <div class="text-container">
            <p class="text">
              {{ referenceIssue?.refText }}
            </p>
          </div>
          <div *ngIf="catMatchReference?.anchors != null && catMatchReference?.anchors.length > 0" class="copy-button-container missing-anchor-reference">
            <ng-container *ngTemplateOutlet="copyButton"></ng-container>

          </div>
        </div>
      </div>
      <ng-container *ngTemplateOutlet="matchAnchors"></ng-container>
      <div class="ref-similarity-code">
        <p class="missing-reference-anchor" style="margin-top: 10px; margin-bottom: 10px;">
          {{ "translate.rev.refMissingAnchor" | translate }}
        </p>
      </div>
    </div>
  </ng-template>

  <ng-template #matchAnchors>
        <ng-container *ngIf="catMatchReference?.anchors != null && catMatchReference?.anchors.length > 0">
          <div>
<!--             <div class="t-small" style="margin-top: 10px; margin-bottom: 10px">
                <a (click)="toggleDisplayAnchors()">
                    <span [ngClass]="!catMatchReference.showAnchors ? 'pi pi-angle-down' : 'pi pi-angle-up'" style="margin-left: 0.3em;"></span>  
                </a>        
            </div> -->

              <mng-anchors style="margin-top: 10px" *ngIf="catMatchReference.showAnchors" [anchors]="catMatchReference.anchors"
              (viewPageAndRef)="viewPageAndRef($event)"
              (anchorPathChange)="onAnchorPathChange()"
              [phrase]="mainPhrase"
              [enableRemoveAnchors]="false"
              [displayActions]="false"
              [disableActions]="disableConsistencyCheckResultsActions"
              [copyAnchors]="true"
              [workingRefAnchors]="ref.anchors"
              >

              </mng-anchors>
            </div>
          </ng-container>
  </ng-template>
  <ng-template #copyButton>
      <copy-all-anchors [catMatchRefAnchors]="catMatchReference.anchors"
      [copyAnchors]="true"
      [phrase]="mainPhrase"
      [disableConsistencyCheckResultsActions]="disableConsistencyCheckResultsActions"
      [workingRefAnchors]="ref.anchors"
      [copyAllAnchors]="onAnchorPathChange()"
      >

      </copy-all-anchors>
  </ng-template>
</div>